<template>
  <standard-layout v-if="betPeriod">
    <template v-slot:heading>
      <div class="d-flex justify-content-between">
        <div>
          <sakali-header :title="betPeriodTimeframe"
                         :super-title="'Tipprunde ' + betPeriod.number + ' vom'"/>
        </div>
        <div>
          <router-link tag="span"
                       class="link hover-sakali-primary"
                       :to="{name:'betPeriodResults', params: {betPeriodNumber: prevBetPeriodNumber}}">
            <fas icon="chevron-left"
                 size="lg"
                 class="me-3"
                 :class="{'muted':betPeriod.prevBetPeriodNumber === 1}">
            </fas>
          </router-link>
          <router-link tag="span"
                       class="link hover-sakali-primary"
                       :to="{name:'betPeriodResults', params: {betPeriodNumber: nextBetPeriodNumber}}">
            <fas icon="chevron-right"
                 size="lg"
                 class="me-3"
                 :class="{'muted':betPeriod.nextBetPeriodNumber === betPeriod.number}">
            </fas>
          </router-link>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="d-flex justify-content-between">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="leagueOnlySwitch" @change="leagueOnly = !leagueOnly">
          <label class="form-check-label" for="leagueOnlySwitch">nur meine Liga</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="friendsOnlySwitch" @change="friendsOnly = !friendsOnly">
          <label class="form-check-label" for="friendsOnlySwitch">nur Freunde</label>
        </div>
        <nav aria-label="Navigation der Liste"
             class="d-flex justify-content-end"
             v-if="betSlipRankings.length > 0">
          <ul class="pagination">
            <li class="page-item page-link"
                @click="prevPage">
              <fas icon="caret-left"
                   :class="{'muted':page === 0}"/>
            </li>
            <li class="page-item page-link"
                @click="nextPage">
              <fas icon="caret-right"/>
            </li>
          </ul>
        </nav>
      </div>
      <ul class="list-group" v-if="betSlipRankings.length > 0">
        <li v-for="(betSlipRank, idx) in betSlipRankings"
            :key="betSlipRank.user.id"
            class="list-group-item d-flex justify-content-between"
            :class="{'odd': idx % 2 === 1, 'list-group-item-highlight': betSlipRank.user.id === userId}">
          <div class="d-flex">
            <div class="d-flex justify-content-end rank-number mt-1">
              <div
                  v-if="betSlipRank.rank > 0 && (idx === 0 || (betSlipRank.rank === (page * elementsPerPage) + idx + 1))">
                {{ betSlipRank.rank }}.
              </div>
            </div>
            <div class="ms-2 d-flex">
              <div class="align-items-center">
                <sakali-user :user="betSlipRank.user"/>
              </div>
            </div>
          </div>
          <div class="points">
            {{ betSlipRank.points | float }}
          </div>
        </li>
      </ul>
      <div v-else class="text-center mt-4">
        Es wurden aktuell noch keine Tipps abgegeben
      </div>
    </template>
    <template v-slot:right1>
      <better-of-the-week
          v-if="betPeriod.running || betPeriod.finished"
          :bet-period-id="betPeriod.id"/>
      <bet-slip-ranking
          v-if="betPeriod.running || betPeriod.finished"
          :betPeriod="betPeriod"
          class="mt-2"/>
      <bet-kings
          v-if="betPeriod.running || betPeriod.finished"
          :bet-period-number="betPeriod.number"
          :live="betPeriod.running"/>
    </template>
  </standard-layout>
</template>

<script>
import sakaliApi from "../sakali-api";
import {mapActions, mapGetters} from 'vuex'
import moment from "moment";

import BetterOfTheWeek from "@/components/bets/BetterOfTheWeek";
import BetKings from "@/components/bets/BetKings";
import BetSlipRanking from "@/components/bets/BetSlipRanking";
import StandardLayout from "@/layouts/StandardLayout"

export default {
  props: {
    betPeriodNumber: [String, Number]
  },
  data() {
    return {
      page: -1,
      elementsPerPage: 20,
      betPeriod: null,
      betSlipRankings: [],
      leagueOnly: false,
      friendsOnly: false
    }
  },
  computed: {
    ...mapGetters(['userId']),
    totalPages() {
      return this.leagueOnly ? 1 : (this.betPeriod ? Math.floor(this.betPeriod.betSlipCount / this.elementsPerPage) : 0)
    },
    betPeriodTimeframe() {
      return moment(new Date(this.betPeriod.start)).format('DD.MM.') + '-'
          + moment(new Date(this.betPeriod.matchEndDate)).format('DD.MM.');
    },
    prevBetPeriodNumber() {
      return this.betPeriod.number > 1 ? this.betPeriod.number - 1 : 1
    },
    nextBetPeriodNumber() {
      return this.betPeriod.hasNext ? this.betPeriod.number + 1 : this.betPeriod.number
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    loadBetPeriod() {
      let bpNumber = this.betPeriodNumber
      if (!bpNumber) {
        sakaliApi.get('/betperiods/current-number').then(n => {
          this.$router.push({name: 'betPeriodResults', params: {betPeriodNumber: n.data}})
        }).catch(err => this.handleError(err))
      } else {
        const url = '/betperiods/by-number/' + bpNumber;
        sakaliApi.get(url)
            .then(response => {
              this.betPeriod = response.data
            })
            .catch(error => {
              this.handleErrorAction(error)
            })
      }
    },
    loadRankings() {
      sakaliApi.get(`/betslipranking/${this.betPeriod.number}`, {
        params: {
          c: false,
          p: this.page,
          e: this.elementsPerPage,
          f: (this.leagueOnly ? 'lo' : '') + (this.friendsOnly ? 'fo' : '')
        }
      }).then(res => {
        const newRankings = res.data
        if (newRankings.length > 0) {
          this.betSlipRankings = newRankings
          if (this.page === -1)
            this.page = Math.floor(this.betSlipRankings[0].listIndex / this.elementsPerPage)
        } else {
          this.betSlipRankings = []
        }
      }).catch(error => this.handleError(error))
    },
    nextPage() {
      this.page++
      this.loadRankings()
    },
    prevPage() {
      this.page = this.page > 0 ? this.page - 1 : 0
      this.loadRankings()
    }
  },
  watch: {
    betPeriodNumber: {
      handler() {
        this.page = -1
        this.loadBetPeriod()
      },
      immediate: true
    },
    betPeriod(newVal) {
      if (newVal)
        this.loadRankings()
    },
    leagueOnly() {
      this.page = -1
      this.loadRankings()
    },
    friendsOnly() {
      this.page = -1
      this.loadRankings()
    }
  },
  components: {
    BetterOfTheWeek, BetKings, BetSlipRanking, StandardLayout
  }
}
</script>

<style>
.rank-number {
  width: 0.75em;
  min-width: 0.75em;
}

.page-link {
  background-color: #F9FFD7;
  color: #85A600;
}

.list-group-item-highlight {
  font-weight: bolder;
  color: white;
  background-color: #fda642 !important;
}
</style>